import React from 'react';
import styled, { css } from 'styled-components';
import {
  PrimaryMedium,
  smokeGray,
  translucentGray,
} from '../../../../cra/src/styling/theme';
import { routes } from '../../../utilities/constants';

export const ExternalURL = styled.a`
  text-decoration: none;
  color: #333d47;
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;

  &:hover {
    text-decoration: none;
    color: ${PrimaryMedium};
    transition: color 0.3s ease-out;
  }

  ${(props) => {
    const { pathName } = props;
    if (pathName && pathName.includes(routes.DRIVE)) {
      return css`
        color: ${smokeGray};
        padding: 2px 8px;
        border-radius: 8px;
        transition: all 0.2s ease-in;
        &:hover {
          background-color: ${translucentGray};
          color: ${smokeGray};
        }
      `;
    }
    return null;
  }}
`;

const ExternalURLComponent = (props) => {
  const {
    listItem: { url, text, onClick, key },
    pathName,
  } = props;
  return (
    <ExternalURL
      href={url}
      onClick={onClick}
      key={key}
      pathName={pathName}
      target="_blank"
      rel="noreferrer"
    >
      {text}
    </ExternalURL>
  );
};

export default ExternalURLComponent;
